const slider_config_type = {
  1: {
    slidesPerView: 3,
    spaceBetween: 20,
    breakpoints: {
      1: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      300: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      500: {
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        slidesPerView: 2,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
    }
  },
  2: {
    slidesPerView: 1,
  } 
};

class CustomSlider extends HTMLElement {
  connectedCallback() {
    this.index = this.dataset.index || 1;

    const section = this.closest('.shopify-section');

    const nextEl = this.querySelector(".swiper-button-next") || section?.querySelector(".swiper-button-next");
    const prevEl = this.querySelector(".swiper-button-prev") || section?.querySelector(".swiper-button-prev");
    const paginationEl = this.querySelector(".swiper-pagination") || section?.querySelector(".swiper-pagination");

    this.navigation = nextEl && prevEl
      ? {
          navigation: {
            nextEl,
            prevEl,
          },
        }
      : {};

    this.pagination = paginationEl
      ? {
          pagination: {
            el: paginationEl,
            clickable: true,
          },
        }
      : {};

    this.config = {
      ...slider_config_type[this.index],
      ...this.navigation,
      ...this.pagination,
      observer: true,
      observeParents: true,
    };

    this.swiper = new Swiper(this, this.config);
  }
}

if (!customElements.get('custom-slider')) {
  customElements.define('custom-slider', CustomSlider);
}